import './InputCheckbox.scss';
import { InputBase } from '@components/Component/Field/Input/Input.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * Class `InputCheckbox` represents a checkbox field.
 */
export class InputCheckbox extends InputBase {
    constructor() {
        super(...arguments);
        this.componentName = 'InputCheckbox';
        /** The type of the input. Defaults to 'checkbox'. */
        this.inputType = 'checkbox';
        /** The record value when the checkbox is checked. Defaults to 'Y'.**/
        this._checkedValue = 'Y';
        /** The record value when the checkbox is unchecked. Defaults to 'N' **/
        this._unCheckedValue = 'N';
    }
    // private _checked?: boolean;
    get checked() { return this.value === this.checkedValue; }
    get checkedValue() { return this._checkedValue; }
    set checkedValue(value) {
        this._propertySet('checkedValue', value);
        this.renderValue();
    }
    get unCheckedValue() { return this._unCheckedValue; }
    set unCheckedValue(value) {
        this._propertySet('unCheckedValue', value);
        this.renderValue();
    }
    /**
     * This method is called to draw the component on the screen.
     */
    draw() {
        super.draw();
        this.inputElement.setAttribute('type', this.inputType);
    }
    setupUserChangeEvent() {
        super.setupUserChangeEvent();
        if (this.iconElement) {
            this.registerEvent('click', this.iconElement, (event) => {
                if (this.disabledState) {
                    return;
                }
                this.handleUserChange(event);
            });
        }
    }
    handleUserChange(event) {
        const oldValue = this._value;
        const newValue = this.value === this.checkedValue ? this.unCheckedValue : this.checkedValue;
        this.userChange(newValue, oldValue, event, true);
    }
    validateKeyPress(_event) {
        return true; // max length logic from input.ts was causing space key to not toggle the checkbox.
    }
    /**
     * Renders the `value` property for this input in the DOM
     * This function is called automatically once the Input has drawn.
     * @returns {Input} - This input instance for chaining calls
     */
    renderValue() {
        if (this.inputElement) {
            this.inputElement.innerText = this.strValue || '';
            if (this.iconElement) {
                if (this.value === this.checkedValue) {
                    DIContainer.getInstance('IconManager').updateIcon(this.iconElement, 'check');
                    this.iconElement.classList.add('checked');
                }
                else {
                    DIContainer.getInstance('IconManager').updateIcon(this.iconElement, '&nbsp;');
                    this.iconElement.classList.remove('checked');
                }
            }
        }
    }
    inputTemplate() {
        super.inputTemplate();
        this.iconTemplate();
    }
    iconTemplate() {
        this.iconElement = DIContainer.getInstance('IconManager').getIconElement('');
        this.fieldInputWrapper?.appendChild(this.iconElement);
    }
    formDesignerPropertiesGet(properties) {
        properties = super.formDesignerPropertiesGet(properties);
        properties.checkedvalue = ({
            id: 'checkedValue',
            value: this.checkedValue,
            componentType: 'Input',
            componentProperties: {},
            captionKey: 'formbuilder_inputcheckbox_checkedvalue',
            propertyGroup: 'data',
            saveFlag: () => !!this.checkedValue && this.checkedValue !== 'Y'
        });
        properties.uncheckedvalue = ({
            id: 'unCheckedValue',
            value: this.unCheckedValue,
            componentType: 'Input',
            componentProperties: {},
            captionKey: 'formbuilder_inputcheckbox_uncheckedvalue',
            propertyGroup: 'data',
            saveFlag: () => this.unCheckedValue !== 'N'
        });
        return properties;
    }
}
InputCheckbox.VERSION = '$Revision: 112183 $';
